export default class GarageSubview {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.garage');
    }
}
